<template>
  <m-loading3/>
  <router-view/>
</template>
<script>
import mLoading3 from '@moeinmdn/miw-alpha-components/src/package/Loading/Loading3'

export default {
  name: "App",
  components: {mLoading3}
}
</script>
<style>
@font-face {
  font-family: yekanbakhfanumbold;
  src: url('https://cdn.mxit.ir/fonts/YekanBakhFaNumBold/YekanBakhFaNum-Bold.eot');
  src: url('https://cdn.mxit.ir/fonts/YekanBakhFaNumBold/YekanBakhFaNum-Bold.eot') format('embedded-opentype'), url('https://cdn.mxit.ir/fonts/YekanBakhFaNumBold/YekanBakhFaNum-Bold.woff2') format('woff2'), url('https://cdn.mxit.ir/fonts/YekanBakhFaNumBold/YekanBakhFaNum-Bold.woff') format('woff'), url('https://cdn.mxit.ir/fonts/YekanBakhFaNumBold/YekanBakhFaNum-Bold.ttf') format('truetype ');
}

.yekanbakhfanumbold-font {
  font-family: yekanbakhfanumbold;
}
</style>